// @ts-strict-ignore
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

type Props = {
  content: CmsApiPage;
};

export function getLastNonScollTrackingContentBlock({ content }: Props) {
  let lastBlock;
  let i = content.contentBlocks.length;

  const setLastBlock = () => {
    lastBlock =
      content.contentBlocks && content.contentBlocks.length
        ? content.contentBlocks[i]
        : null;
  };

  setLastBlock();

  while (lastBlock && lastBlock.type === 'SCROLL_TRACKING') {
    i -= 1;
    setLastBlock();
  }

  return lastBlock;
}
